import { render, staticRenderFns } from "./bMarkdownInput.vue?vue&type=template&id=164ffca4&scoped=true"
import script from "./bMarkdownInput.ts?vue&type=script&lang=ts&external"
export * from "./bMarkdownInput.ts?vue&type=script&lang=ts&external"
import style0 from "./bMarkdownInput.vue?vue&type=style&index=0&id=164ffca4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164ffca4",
  null
  
)

export default component.exports